<template>
  <div class="menu_bar">
  <div v-show="hide_full_menu" class="menu_bar_full">
    <div class="logo_area">
<!--      <img src="../../assets/images/logo.png"/>-->
      <div class="logo_name" v-show="menu_bar.size=='full'">
        <span class="logo_name_1">{{common_sys_name}}</span>
      </div>
      <div style="clear:both;"></div>
    </div>
    <div class="menu_area" style="height:calc(100% - 65px - 30px);">
      <div class="item_parent no_select point_hand">
        <div :class="`item-title ${$route.fullPath=='/back/map'?'menu_active':''}`" @click="fun_to_page('/back/map')">
          <i class="fa el-icon-house" />
          <span>系统首页</span>
        </div>
      </div>
      <div v-for="(item,i) of menus.rows" v-if="item.levelCode.length == 3" :class="`item_parent no_select point_hand ${item.isExpand?'is_expand':''}`">
        <div :class="`item-title ${current_code.startsWith(item.levelCode)?'menu_active':''}`" @click="fun_changesidebar(item.levelCode)" :title="item.resourceName">
          <i :class="'fa ' + item.defaultPicture" />
          <span>{{ item.resourceName }}</span>
          <i v-if="!item.isExpand" class="fa fa-angle-right iconr"></i>
          <i v-else class="fa fa-angle-down iconr"></i>
        </div>
        <div class="menu_child" v-show="item.isExpand">
          <template v-for="ntem in menus.rows">
            <div v-if="ntem.levelCode.startsWith(item.levelCode) && ntem.levelCode.length == 6" :class="`item-meta-title ${ntem.levelCode==current_code?'select':''}`">
              <router-link v-if="ntem.nodeType!='N'"
                :to="ntem.url"
                class="router_default"><i :class="'fa ' + ntem.defaultPicture" style="" /> {{ ntem.resourceName }}</router-link>
              <a v-else :href="ntem.url" class="router_default" target="_blank"><i :class="'fa ' + ntem.defaultPicture" style="" /> {{ ntem.resourceName }}</a>
            </div>
            <template v-else></template>
          </template>
        </div>
      </div>
    </div>
    <div style="line-height:30px;text-align: center;font-size:12px;font-weight:300;">服务器时间：{{server_date}} {{server_time}}</div>
  </div>
  <div v-show="menu_bar.size=='mini'" class="base_menu_bar_mini">
    <div class="logo_area">
<!--      <img src="../../assets/images/logo.png"/>-->
      <div style="clear:both;line-height:70px;text-align:center;font-size:20px;">LOGO</div>
    </div>
    <div class="menu_area" style="height:calc(100% - 65px - 30px);">
      <div class="item_parent no_select point_hand">
        <div :class="`item-title ${$route.fullPath=='/back/dashboard'?'menu_active':''}`" @click="fun_to_page('/back/dashboard')">
          <i class="fa el-icon-house" />
          <span>系统首页</span>
        </div>
      </div>
      <div v-for="(item,i) of menus.rows" v-if="item.levelCode.length == 3" :class="`item_parent no_select point_hand`" @mouseleave="fun_closesidebar">
        <div :class="`item-title ${current_code.startsWith(item.levelCode)?'menu_active':''} ${item.isExpand?'menu_active':''}`"
             :ref="item.id"
             @mouseenter="fun_changesidebar(item.levelCode)">
          <i :class="'fa ' + item.defaultPicture" />
          <span>{{ item.resourceName }}</span>
          <i v-if="!item.isExpand" class="fa fa-angle-down iconr"></i>
          <i v-else class="fa fa-angle-right iconr"></i>
        </div>
        <div class="menu_child shadow" v-show="item.isExpand" :style="`top:${item.top}px;left:${item.left}px;`"
        >
          <div class="menu_level2_tit">{{item.resourceName}}</div>
          <template v-for="ntem in menus.rows">
            <div v-if="ntem.levelCode.startsWith(item.levelCode) && ntem.levelCode.length == 6" :class="`item-meta-title ${ntem.levelCode==current_code?'select':''}`">
              <router-link v-if="ntem.nodeType!='N'"
                :to="ntem.url"
                class="router_default"><i :class="'fa ' + ntem.defaultPicture" style="" /> {{ ntem.resourceName }}</router-link>
              <a v-if="ntem.nodeType=='N'" :href="ntem.url" class="router_default" target="_blank"><i :class="'fa ' + ntem.defaultPicture" style="" /> {{ ntem.resourceName }}</a>
            </div>
            <template v-else></template>
          </template>
        </div>
      </div>
    </div>
    <div style="line-height:30px;text-align: center;font-size:12px;font-weight:300;">{{server_time}}</div>
  </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props:['menu_bar'],
  data() {
    return {
      menus:{rows:[]},
      current_code:'',
      common_sys_name:'',
      hide_full_menu:false,
      server_date:'',server_time:'',
    };
  },
  methods: {
    fun_to_page(_url){
      this.$router.push(_url);
      this.fun_calc_select();
    },
    fun_closesidebar(){
      let _this = this;
      for(var i=0;i<_this.menus.rows.length;i++){
        let _item = _this.menus.rows[i];
        _item.isExpand=false;
        _this.$set(_this.menus.rows,i,_item);
      }
    },
    fun_changesidebar(_code) {
      let _this = this;
      for(var i=0;i<_this.menus.rows.length;i++){
        let _item = _this.menus.rows[i];
        if(_item.levelCode==_code){
          let _ele = _this.$refs[_item.id];
          Object.assign(_item,{top:_ele[0].offsetTop,left:_ele[0].offsetLeft+_ele[0].offsetWidth});
          console.log(_item.isExpand);
          _item.isExpand=!_item.isExpand;
          _this.$set(_this.menus.rows,i,_item);
        }else{
          _item.isExpand=false;
          _this.$set(_this.menus.rows,i,_item);
        }
      }
    },
    fun_calc_select(){
      var _this = this;
      this.current_code = '';
      console.log(this.$route)
      for(var i of this.menus.rows){
        i.isExpand = false;
        if(i.url==this.$route.path) this.current_code = i.levelCode;
      }
      if(this.menu_bar.size=='full') {
        this.hide_full_menu = true;
        this.menus.rows.forEach(n=>{if(this.current_code.startsWith(n.levelCode)&&n.levelCode.length==3)n.isExpand=true;})
      }else{
        setTimeout(()=>{_this.hide_full_menu = false;},400)
      }
    },
  },
  watch:{
    'menu_bar.size'(n,o){
      this.fun_calc_select()
    }
  },
  mounted() {
    var _this = this;
    _this.menus = {rows:JSON.parse(localStorage.getItem('vue_store_menu'))};
    _this.menus.rows.forEach(n=>{n.param=n.functionParameter?JSON.parse(n.functionParameter):{}})

    _this.fun_calc_select();
    _this.$watch('$route', (to, from) => {
      console.log(_this.$route)
      _this.fun_calc_select();
    });

    this.current_user = this.$store.state.user;
    this.common_sys_name = process.env.VUE_APP_SYSTEM_NAME;
    document.title = this.common_sys_name;

    if(window['server_timer']==undefined) window['server_timer']=setInterval(function(){
      let time = localStorage.getItem('server_time');
      if(time==undefined||time==null||time.length!=19) time = zyl.parse_time(new Date());
      let current = zyl.parse_time(new Date(new Date(time).getTime()+1000));
      _this.server_date = current.substring(0,10);
      _this.server_time = current.substring(11);
      localStorage.setItem('server_time',current)
    },1000);
  },
};
</script>

<style scoped>
</style>
